(function($){
    $('form.advanced-search-filters button[type=reset]').click(function(){
        reset_atoimeksianto_search_filters();
        $('#search-filter-content-type').val('');
        return false;
    });
    $('#search-filter-content-type').on('change', function(){
        if(this.value == 'atoimeksianto'){
            $('#search-filter-group-atoimeksianto').removeClass('hidden');
        }else{
            reset_atoimeksianto_search_filters();
        }
    });
    $('#hallinnonala-list input[type=checkbox]').each(function(){
        var hide = true;
        var category = $(this).parent().data('category');
        $(this).on('change', function(){
            if(this.checked) {
                hide = false;   
            }else{
                hide = true;
            }
            $("#virasto-list .checkbox").each(function(){
                if($(this).data('category-parent') == category){
                    if(hide){
                        $(this).addClass('hidden');
                        $(this).find('input[type=checkbox]').prop('checked', false);
                    }else{
                        $(this).removeClass('hidden');
                    }
                }
            });
            virasto_list_visibility();
        });
        
    });
    virasto_list_visibility();
})( jQuery );

function virasto_list_visibility(){
    if(jQuery('#virasto-list .checkbox').not('.hidden').length == 0){
        jQuery('#virasto-list').addClass('hidden');
    }else{
        jQuery('#virasto-list').removeClass('hidden');
    }
}

function reset_atoimeksianto_search_filters(){
    jQuery('form.advanced-search-filters select[name="finished_year_start"]').val('');
    jQuery('form.advanced-search-filters select[name="finished_year_end"]').val('');
    jQuery('form.advanced-search-filters input[type="checkbox"]').prop('checked', false);
    jQuery('#virasto-list').addClass('hidden');
    jQuery('#search-filter-group-atoimeksianto').addClass('hidden');
}